import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import React from "react";
import MentionTextField from "./MentionTextField";

const TarefaModal = ({
  open,
  onClose,
  onSubmit,
  formData,
  setFormData,
  clientes,
  usuarios,
  usuariosEscritorio = [],
  editingTarefa,
  salvando,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {editingTarefa ? "Editar tarefa" : "Nova tarefa"}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Cliente</InputLabel>
              <Select
                value={formData.cliente_id}
                label="Cliente"
                onChange={(e) =>
                  setFormData({ ...formData, cliente_id: e.target.value })
                }
                required
              >
                {clientes.map((cliente) => (
                  <MenuItem key={cliente.id} value={cliente.id}>
                    {cliente.nome || cliente.fantasia}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Descrição"
              value={formData.descricao}
              onChange={(e) =>
                setFormData({ ...formData, descricao: e.target.value })
              }
              required
              multiline
              rows={2}
            />

            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={ptBR}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <DatePicker
                  label="Data de vencimento"
                  value={formData.data_vencimento}
                  onChange={(newValue) =>
                    setFormData({ ...formData, data_vencimento: newValue })
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth required />
                  )}
                />

                <TimePicker
                  label="Hora de vencimento"
                  value={formData.hora_vencimento}
                  onChange={(newValue) =>
                    setFormData({ ...formData, hora_vencimento: newValue })
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth required />
                  )}
                />
              </Box>
            </LocalizationProvider>

            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={formData.status}
                label="Status"
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.value })
                }
              >
                <MenuItem value="pendente">Pendente</MenuItem>
                <MenuItem value="em_andamento">Em andamento</MenuItem>
                <MenuItem value="enviado">Enviado</MenuItem>
                <MenuItem value="enviado_atrasado">Enviado com atraso</MenuItem>
                <MenuItem value="pago">Pago</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Responsável</InputLabel>
              <Select
                value={formData.responsavel_id}
                label="Responsável"
                onChange={(e) =>
                  setFormData({ ...formData, responsavel_id: e.target.value })
                }
              >
                <MenuItem value="">Nenhum</MenuItem>
                {usuarios.map((usuario) => (
                  <MenuItem key={usuario.id} value={usuario.id}>
                    {usuario.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <MentionTextField
              label="Comentários"
              value={formData.comentarios || ""}
              onChange={(e) =>
                setFormData({ ...formData, comentarios: e.target.value })
              }
              usuarios={usuariosEscritorio}
              placeholder="Adicione comentários sobre a tarefa... (use @ para mencionar usuários)"
              rows={3}
            />

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={formData.priorizar}
                onChange={(e) =>
                  setFormData({ ...formData, priorizar: e.target.checked })
                }
                color="primary"
              />
              <Typography>Priorizar esta tarefa</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={salvando}>
            {salvando ? (
              <CircularProgress size={20} />
            ) : editingTarefa ? (
              "Atualizar"
            ) : (
              "Criar"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TarefaModal;
